import * as ACT from '../actions/orderActions';

const initialState = {
    createdUser : false
};

export function order(state = initialState, action) {
    switch (action.type) {


        case ACT.ORDER_GET_ITEM:
            return {
                ...state,
                getItem: action.data,
            };
        case ACT.ORDER_SET_ITEM:
            return {
                ...state,
                targetItem: action.data,
            };
        case ACT.ORDER_ADD_ITEM:
            return {
                ...state,
                addItem: action.data,
            };
        case ACT.ORDER_SET_ALL:
            return {
                ...state,
                list: action.data,
            };
        case ACT.ORDER_SET_ALL_FOR_EXCEL:
            return {
                ...state,
                listForExcel: action.data,
            };
        case ACT.ORDER_ITEM_ID:
            return {
                ...state,
                orderItemId: action.data,
            };
        case ACT.ORDER_ASSIGN_ITEM:
            return {
                ...state,
                orderAssignItem: action.data,
            };
        case ACT.ORDER_CREATED_USER:
            return {
                ...state,
                createdUser: action.data,
            };


        case ACT.ORDER_FIELD_ERROR:
            if (state.fieldsError)
                var fieldsErrorPushed = state.fieldsError;
            else
                fieldsErrorPushed = {};
            fieldsErrorPushed[action.fieldName] = (action.fieldData != {}) ? action.fieldData : {err: true};


            return {
                ...state,
                fieldsError: fieldsErrorPushed,
                formError: true,
            };
        case ACT.ORDER_FIELD_RESET_ERROR:
            return {
                ...state,
                fieldsError: {},
                formError: false,
            };
        case ACT.INVOICE_GET_ITEM:
            return {
                ...state,
                invoiceGetItem: action.data,
            };
        case ACT.INVOICE_SET_ITEM:
            return {
                ...state,
                invoiceTargetItem: action.data,
            };
        case ACT.INVOICE_ADD_ITEM:
            return {
                ...state,
                invoiceAddItem: action.data,
            };
        case ACT.INVOICE_SET_ALL:
            return {
                ...state,
                invoiceList: action.data,
            };

        default:
            return state
    }
};
